export const EXIT_CONFIRMATION_COPY = {
  title: 'You haven’t finished yet!',
  subTitle: 'Are you sure you want to exit?',
  leave: 'Yes, Exit',
  cancel: 'No, Cancel',
};
